module.exports = ".input-w-checkbox {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n}\r\n\r\n.input-w-checkbox div {\r\n    width: 100px;\r\n    margin-left: 0.5rem;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/trips/daily-trip-form/daily-trip-form.component.css
// module id = ./src/app/components/trips/daily-trip-form/daily-trip-form.component.css
// module chunks = main